
<template>
  <div class="content">
    <el-row style="width: 94%;
    padding-top: 3%;
    margin-left: 3%;
    background-color: white;
    text-align: left;
    font-family: Calibri;
    padding-bottom:200px;">
      <el-col>
        <el-row>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          MaxEnt combines the data on the presence of a given species within a grid with environmental variables representing different environmental gradients within that grid to judge whether the area is suitable for a particular species. The overall research framework for the study is shown in Figure 1.
        </el-row>
        <el-row style="text-align: center;padding-top: 10px;">
          <img src="http://bunjs.aiside.top/4-1.png"/><br/>
          <span>Fig. 1 Research framework for predicting rice suitability</span>
        </el-row>
        <el-row>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Environmental variables and Samples: After the selection of sample points and environment variables (Su et al., 2021), a total of 2228 samples and 17 environment variables were used in prediction future suitable areas for rice.
        </el-row>
        <el-row>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          The Maxent model was trained to predict future land suitability for rice cultivation for 2010s (base-term), 2030s (near-term), and 2050s (medium-term) periods under different future climate scenarios. In order to reduce errors, the number of simulations is 30 times, and the average result is the final result.
        </el-row>

        <el-row>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          To balance the supply and demand of rice among countries, this study redistributed future rice cultivation. On the supply side, we used suitability changes to predict the initial rice harvest area as the starting value of the iteration. The rice harvest area was adjusted by comparing the countries’ rice supply and demand. If the supply exceeded demand, reduced rice harvest area, and vice versa. This model can be expressed as a multi-objective optimization model (equation 1-4).
        </el-row>
        <el-row style="text-align: center;">
          <img src="http://bunjs.aiside.top/4-3.png"/>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    name: "RiceDistributionPrediction"
  }
</script>

<style scoped>


  .r_title{
    font-weight: bold;
    font-size: 2.5rem;
  }
  .content{
    overflow-y: scroll;
    line-height: 40px;
    font-size: 2.2rem;
  }
  .content::-webkit-scrollbar {
    display: none;/*隐藏滚动条*/
  }
</style>



// WEBPACK FOOTER //
// src/view/BSD/About/RiceDistributionPrediction.vue